import { gql } from "@apollo/client";
/** Shared by Bullrun web/mobile LiveUpdatesProvider cache writes. */
export const SPORT_METADATA_FRAGMENT = gql `
  fragment SportMetadata on StandardizedPredictionEvent {
    id
    standardizedInstrumentId
    sportMetadata {
      isLive
      gameStatus
      homeTeamScore
      awayTeamScore
      period
      elapsed
      homeTeam {
        name
        abbreviation
        logo
        color
        record
      }
      awayTeam {
        name
        abbreviation
        logo
        color
        record
      }
      sportType
      league
      scheduledStartTime
    }
  }
`;
export const PREDICTION_READ_FRAGMENT = gql `
  fragment PredictionRead on StandardizedPredictionEvent {
    id
    standardizedInstrumentId
    volume {
      start {
        timestamp
        value
      }
      end {
        timestamp
        value
      }
      changeInPercentage
    }
    markets {
      outcomes {
        externalTokenId
        price {
          start {
            timestamp
            value
          }
          end {
            timestamp
            value
          }
          changeInPercentage
        }
      }
    }
  }
`;
export const PREDICTION_WRITE_FRAGMENT = gql `
  fragment PredictionWrite on StandardizedPredictionEvent {
    id
    standardizedInstrumentId
    volume {
      start {
        timestamp
        value
      }
      end {
        timestamp
        value
      }
      changeInPercentage
    }
    markets {
      outcomes {
        externalTokenId
        price {
          start {
            timestamp
            value
          }
          end {
            timestamp
            value
          }
          changeInPercentage
        }
      }
    }
  }
`;
